import { Box } from "@mui/material";
import ArchivedOverlay from "@/modules/common/components/ui-kit/archived-overlay";
import EditLocation from "@/modules/lead-page/new/components/sidebar/fields/location";

export default function LeadLocation({ isArchived }: { isArchived?: boolean }) {
  return (
    <ArchivedOverlay isArchived={isArchived} sx={{ width: "100%" }}>
      <Box sx={{ width: "100%" }}>
        <EditLocation />
      </Box>
    </ArchivedOverlay>
  );
}
